import React from "react";

const PHONE_TEL = "tel:+33184162060";

export const EmergencyBanner = () => (
  <div className="bg-[#0F172A] text-white text-xs sm:text-sm font-bold w-full">
    <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-center tracking-wide">
      <span className="inline-block w-2 h-2 rounded-full bg-[#FF5A1F] animate-pulse" />
      <span>URGENCE 24/7 — INTERVENTION DANS TOUT LE 93 EN 30 MIN</span>
      <a
        href={PHONE_TEL}
        data-testid="banner-call-link"
        className="hidden sm:inline-block ml-3 text-[#FF5A1F] hover:underline"
      >
        01.84.16.20.60
      </a>
    </div>
  </div>
);

export default EmergencyBanner;
